import { render, staticRenderFns } from "./NieuwsmakerModal.vue?vue&type=template&id=592b454c"
import script from "./NieuwsmakerModal.vue?vue&type=script&lang=js"
export * from "./NieuwsmakerModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports